import React from 'react';
import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { NEWS_ITEMS, NEWS_PATH, type NewsItem } from '../data/news';
import SectionHead from './SectionHead';
import NewsList from './NewsList';
import layout from '../styles/layout.module.css';
import styles from './NewsSection.module.css';

/** トップページに出す件数。残りは /news で読める */
export const HOME_NEWS_COUNT = 3;

interface NewsSectionProps {
  items?: readonly NewsItem[];
}

const NewsSection: React.FC<NewsSectionProps> = ({ items = NEWS_ITEMS }) => {
  const { elementRef, isVisible } = useScrollAnimation<HTMLDivElement>();

  return (
    <section id="news" className={layout.section} aria-labelledby="news-title">
      <div
        ref={elementRef}
        className={`${layout.wrap} ${layout.sectionInner} slide-up ${isVisible ? 'visible' : ''}`}
      >
        <SectionHead
          eyebrow="NEWS"
          title="お知らせ"
          titleId="news-title"
          lead="会社からのお知らせと、登壇や執筆の記録を載せていきます。"
        />

        <NewsList items={items.slice(0, HOME_NEWS_COUNT)} />

        <p className={styles.more}>
          <Link to={NEWS_PATH} className={layout.inlineLink}>
            すべてのお知らせ →
          </Link>
        </p>
      </div>
    </section>
  );
};

export default NewsSection;
